
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fcdzS", function(module, exports) {

$parcel$export(module.exports, "isLoadingFromCreate", () => $33212fbe7ea4a504$export$715eeb96fb707dd0);
$parcel$export(module.exports, "isJSOnlyPreloadEditSources", () => $33212fbe7ea4a504$export$14d0864bdf9ebc83);
$parcel$export(module.exports, "isEditSourceInitialLoad", () => $33212fbe7ea4a504$export$54a66e2eab775880);

var $jKIuI = parcelRequire("jKIuI");
const $33212fbe7ea4a504$export$715eeb96fb707dd0 = (editSource)=>editSource?.indexOf('CREATE_') === 0; // See constants.ts
const $33212fbe7ea4a504$export$14d0864bdf9ebc83 = (editSource)=>$33212fbe7ea4a504$export$715eeb96fb707dd0(editSource) || (0, $jKIuI.InitialLoadEditSources).includes(editSource);
const $33212fbe7ea4a504$export$54a66e2eab775880 = (editSource)=>(0, $jKIuI.InitialLoadEditSources).includes(editSource);

});


//# sourceMappingURL=EditPageLoadingListener.0de697a3.js.map
